import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

import { db } from "@/firebase/firebaseConfig";
import {
  deleteDoc,
  doc,
  getDoc,
  onSnapshot,
  updateDoc,
} from "firebase/firestore";
import ReactQuill from "react-quill";
import Button from "../UI/Button";

const EditModuleLessons = ({ moduleId, currentCollection }) => {
  const navigate = useNavigate();

  const [lessonList, setLessonList] = useState([]);

  useEffect(() => {
    const moduleRef = doc(db, currentCollection, moduleId);

    const unsubscribe = onSnapshot(moduleRef, async (docSnap) => {
      if (docSnap.exists()) {
        const moduleData = docSnap.data();
        const videoRefs = moduleData.videos || [];

        const videoDataPromises = videoRefs.map(async (videoRef) => {
          const videoDoc = await getDoc(videoRef);
          return videoDoc.exists()
            ? { id: videoDoc.id, ...videoDoc.data() }
            : null;
        });

        const videos = (await Promise.all(videoDataPromises)).filter(Boolean);
        setLessonList(videos);
      }
    });

    return () => unsubscribe();
  }, [moduleId, currentCollection]);

  const handleDragEnd = async (result) => {
    if (!result.destination) return;

    const reorderedLessons = [...lessonList];
    const [movedLesson] = reorderedLessons.splice(result.source.index, 1);
    reorderedLessons.splice(result.destination.index, 0, movedLesson);

    setLessonList(reorderedLessons);

    const reorderedLessonRefs = reorderedLessons.map((lesson) =>
      doc(db, `${moduleId}Videos`, lesson.id)
    );

    try {
      const docRef = doc(db, currentCollection, moduleId);
      await updateDoc(docRef, { videos: reorderedLessonRefs });
      alert("Порядок уроков обновлен");
    } catch (error) {
      console.error("Ошибка при обновлении Firebase:", error);
    }
  };

  const handleDeleteModule = async (video) => {
    const confirmDelete = window.confirm(
      "Вы уверены, что хотите удалить этот урок?"
    );
    if (!confirmDelete) return;

    try {
      const videoRef = doc(db, `${moduleId}Videos`, video.id);
      await deleteDoc(videoRef);

      const updatedLessons = lessonList.filter(
        (lesson) => lesson.id !== video.id
      );
      setLessonList(updatedLessons);

      const moduleRef = doc(db, currentCollection, moduleId);
      const updatedVideoRefs = updatedLessons.map((lesson) =>
        doc(db, `${moduleId}Videos`, lesson.id)
      );

      await updateDoc(moduleRef, { videos: updatedVideoRefs });

      alert("Урок успешно удален");
    } catch (error) {
      console.error("Ошибка при удалении урока:", error);
    }
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="lessons">
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className="edit-module-table layout"
          >
            <ul className="table-body">
              {lessonList?.map((video, index) => (
                <Draggable
                  key={video.id}
                  draggableId={video.id.toString()}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <li
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className={` table-body-item
                        ${snapshot.isDragging ? "table-row " : ""}`}
                    >
                      <div className="cell-title">{video.title}</div>

                      <div className="cell-content">
                        <ReactQuill
                          value={video.content}
                          readOnly
                          theme="snow"
                          modules={{
                            toolbar: false,
                          }}
                          className="lessonPage__content"
                        />
                      </div>
                      <div className="cell-video-url">
                        {video.url && (
                          <video width={200} src={video.url} controls></video>
                        )}
                      </div>

                      <div className="cell-buttons">
                        <Button
                          title="Редактировать"
                          color="blue"
                          onClick={() =>
                            navigate(`/edit-module/lesson/${video.id}`, {
                              state: {
                                video: video,
                                id: moduleId,
                                currentCollection: currentCollection,
                              },
                            })
                          }
                        ></Button>
                        <Button
                          title="Удалить"
                          color="red"
                          onClick={() => handleDeleteModule(video)}
                        ></Button>
                      </div>
                    </li>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </ul>
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default EditModuleLessons;
